/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {
    class EgiftsController extends Meevo.Components.CommonClasses.CommonControllerBase  {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$state",
            '$scope',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.plugins.egifts.egiftsService',
            '$translate',
            '$mdDialog',
            '$q'];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected $scope: angular.IScope,
            protected contextParams: Meevo.ContextParamsService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected egiftsService: Meevo.Plugins.Egifts.EgiftsService,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService,
            protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
            this.createContext();
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_EGIFT).then(() => {

                this.egiftsService.getSettings().then(settings => {
                    this.context = new EgiftsContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.egiftsService, this.$scope, this.$translate, this.$mdDialog, this.$q, this.$rootScope, settings, this.contextParams);
                    super.createContext();
                    this.busyService.stop();
                });
            });
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }
    }

    angular.module('meevo.plugins.egifts')
        .controller('meevo.plugins.egifts.EgiftsController', EgiftsController);
}